/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, BusinessLottie, NetworkLottie } from '@components/atoms'

import { useAppSelector } from '@redux/index'
import { deepPurple } from '@mui/material/colors'

export const MainHomeBanner = () => {
	// redux state
	const systemName: string = useAppSelector(state => state.config.systemName)

	// variables
	const title = `${systemName}`

	return (
		<View css={style} className="contentTopView">
			<View className="contentTitleView">
				<Text category="h1" style={{ fontFamily: 'audiowideRegular' }}>
					{title}
				</Text>
				<Text category="h5">뮤지션의 가치를 함께 키우는 기업</Text>
			</View>
			<View className="contentImageView">
				<View className="contentImageInnerView">
					<BusinessLottie />
				</View>
			</View>

			<View className="contentImage2View">
				<View className="contentImage2InnerView">
					<NetworkLottie />
				</View>
			</View>
			<View className="contentImageBackgroundView" />
			<View className="contentImageBackgroundView2" />
			<View className="backgroundLineOuterView">
				<View
					className="backgroundLineView"
					css={{ width: '0.4rem', height: '2px', top: '-0.5rem', left: '9rem' }}
				/>

				<View
					className="backgroundLineView"
					css={{ width: '10rem', height: '2px', top: '0rem', left: '1rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '0.4rem', height: '2px', top: '1rem', left: '7rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '16rem', height: '1px', top: '2.5rem', left: '3rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '0.4rem', height: '2px', top: '3rem', left: '12rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '8rem', height: '2px', top: '4rem', left: '0rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '0.4rem', height: '2px', top: '4.5rem', left: '4rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '0.4rem', height: '2px', top: '5rem', left: '15rem' }}
				/>
				<View
					className="backgroundLineView"
					css={{ width: '32rem', height: '1px', top: '6rem', left: '7rem' }}
				/>
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	zIndex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '20rem',
	background: deepPurple[800],
	overflow: 'hidden',

	'.contentTitleView': {
		position: 'absolute',
		zIndex: 3,
		left: '10rem',
		textAlign: 'left',
		color: '#fff',

		'.text.h1': {
			fontSize: '40px',
			margin: 0,
			marginBottom: '1rem',
		},
	},

	'.contentImageView': {
		position: 'absolute',
		width: 'fit-content',
		height: 'fit-content',
		right: '10rem',

		'.contentImageInnerView': {
			position: 'relative',
			zIndex: 3,
		},
	},

	'.contentImage2View': {
		position: 'absolute',
		zIndex: 1,
		width: 'fit-content',
		height: 'fit-content',
		left: '1rem',
		opacity: 0.3,
	},

	'.contentImageBackgroundView': {
		position: 'absolute',
		zIndex: 2,
		width: '40rem',
		height: '25rem',
		top: 0,
		right: 0,
		borderRadius: '40% 0 0 70%',
		background: '#FFF',
		opacity: 0.2,
	},

	'.contentImageBackgroundView2': {
		position: 'absolute',
		zIndex: 1,
		width: '60rem',
		height: '25rem',
		top: 0,
		right: 0,
		borderRadius: '40% 0 0 70%',
		background: '#FFF',
		opacity: 0.1,
	},

	'.backgroundLineOuterView': {
		position: 'absolute',
		alignItems: 'center',
		width: '20rem',
		height: '6rem',
		top: '7rem',
		right: '30rem',
		opacity: 0.2,

		'.backgroundLineView': {
			position: 'absolute',
			zIndex: 5,
			background: '#FFF',
		},
	},
})
